import { ReduxStore } from 'store/types';

function changeStatusIsLoading(state: ReduxStore): boolean {
  return state.manufacturer.changeStatus.config.isLoading;
}

export default changeStatusIsLoading;
